export default __webpack_public_path__ + "static/media/ai.0b59c0f8.png";